import React, { Component } from "react";
import "./App.css";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Uitleg from "./components/Uitleg";
import Vrijwilligers from "./components/Vrijwilligers/Vrijwilligers";
import Klanten from "./components/Klanten/Klanten";
import Opdrachten from "./components/Opdrachten/Opdrachten";
import Overzichten from "./components/Overzichten/Overzichten";
import Navbar from "./components/CustomNavbar";
import logo from "./LogoAHD.jpg";
import { Paper } from "@material-ui/core";
import { observer } from "mobx-react";
//import Login from "./components/Login";

//import firebase from "firebase/app";
import "firebase/auth";
import { firebase, vrijwilligers } from "./models/firestore";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import firebaseui from "firebaseui";

import styles from "./AppStyles.css"; // This uses CSS modules.
import "./firebase-styling.global.css"; // Import globally.

const App = observer(
  class App extends Component {
    uiConfig = {
      signInFlow: "redirect",
      //CredentialHelper: [firebase.auth.CredentialHelper.NONE],
      signInOptions: [
        // firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.EmailAuthProvider.PROVIDER_ID
      ],
      callbacks: {
        signInSuccessWithAuthResult: () => false
      },
      credentialHelper: firebaseui.auth.CredentialHelper.NONE
    };

    state = {
      isSignedIn: undefined
    };

    /**
     * @inheritDoc
     */
    componentDidMount() {
      this.unregisterAuthObserver = firebase.auth().onAuthStateChanged(user => {
        this.setState({
          isSignedIn: !!user
          //
        });
      });
    }
    /**
     * @inheritDoc
     */
    componentWillUnmount() {
      this.unregisterAuthObserver();
    }

    // vrijwilligers.docs.map(doc => {
    //   alert(doc.data.email);
    // });

    render() {
      if (this.state.isSignedIn) {
        firebase.auth().useDeviceLanguage();
        let gebruikersNaam = "";
        let gebruikersrollen = "";
        // const { disabled } = this.state;
        //let children = undefined;
        const { email } = this.props;
        const { docs } = vrijwilligers;

        // let gebruiker = undefined;
        // gebruiker = vrijwilligers.docs.findIndex(email => {
        //   email === firebase.auth().currentUser.email;
        // });
        // if (gebruiker) {
        //   alert(gebruiker);
        // }
        // vrijwilligers.query = ref =>
        //   ref.where("email", "==", firebase.auth().currentUser.email);

        // if (vrijwilligers.docs.data) {
        //   alert(vrijwilligers.doc.data.email);
        // }

        //Moet hier nog een promise omheen ????
        function VindIngelogdeGebruiker(element) {
          if (element.data.email) {
            // alert(
            //   "Gevonden" +
            //     element.data.email +
            //     "ingelogd als email" +
            //     firebase.auth().currentUser.email
            // );
            if (
              element.data.email.indexOf(firebase.auth().currentUser.email) > -1
            ) {
              //alert("Succesvol gebruiker gevonden");
              //console.log(firebase.auth().currentUser);

              gebruikersNaam = element.data.displayNaam;
              gebruikersrollen = element.data.rollen;

              //TODO: Uitzoeken hoe je een disabled user kan vinden en dan uitloggen.
              // if (firebase.auth.currentUser.disabled) {
              //   firebase.auth().signOut();
              // }
              return element.data.email === email;
            }
          }
        }
        docs.findIndex(VindIngelogdeGebruiker);
        //Gebruikersnaam en rollen ophalen
        // async function isGebuikerValide() {
        //   //await alert("Stop ier");
        //   await docs.findIndex(VindIngelogdeGebruiker);
        //   if (gebruikersNaam === "") {
        //     alert("ga nu uitloggen");
        //     firebase.auth().signOut();
        //   }
        // }

        // isGebuikerValide();
        //todos.query = (ref) => ref.where('finished', '==', false).orderBy('finished', 'asc').limit(20);

        return (
          <Router>
            {/* <Switch> */}
            {/* <Route path="/login" component={Login} exact /> */}
            {/* <Redirect from="/logout" to="/login" /> */}
            {/* <AuthenticatedComponent> */}
            <div>
              <Navbar gebruikersNaam={firebase.auth().currentUser.email} />
              {/* <Route exact path="/" component={Home} />
            <Route path="/medewerkers" component={Medewerkers} /> */}

              <Route exact path="/" component={Uitleg} />
              <Route
                path="/klanten"
                render={props => (
                  <Klanten
                    email={firebase.auth().currentUser.email}
                    gebruikersNaam={gebruikersNaam}
                    gebruikersrollen={gebruikersrollen}
                  />
                )}
                //component={Vrijwilligers}
                //gebruikersNaam={this.state.gebruikersNaam}
              />
              <Route
                path="/vrijwilligers"
                render={props => (
                  <Vrijwilligers
                    email={firebase.auth().currentUser.email}
                    gebruikersNaam={gebruikersNaam}
                    gebruikersrollen={gebruikersrollen}
                  />
                )}
                //component={Vrijwilligers}
                //gebruikersNaam={this.state.gebruikersNaam}
              />
              <Route
                path="/opdrachten"
                render={props => (
                  <Opdrachten
                    email={firebase.auth().currentUser.email}
                    gebruikersNaam={gebruikersNaam}
                    gebruikersrollen={gebruikersrollen}
                  />
                )}
                //component={Vrijwilligers}
                //gebruikersNaam={this.state.gebruikersNaam}
              />
              <Route
                path="/overzichten"
                render={props => (
                  <Overzichten
                    email={firebase.auth().currentUser.email}
                    gebruikersNaam={gebruikersNaam}
                    gebruikersrollen={gebruikersrollen}
                  />
                )}
                //component={Vrijwilligers}
                //gebruikersNaam={this.state.gebruikersNaam}
              />
              {/* </AuthenticatedComponent> */}
              {/* </Switch> */}
            </div>
          </Router>
        );
      } else {
        return (
          <div
            style={{
              //paddingTop: "50px",
              //paddingLeft: "200px",
              //paddingRight: "200px",

              height: "100%"
            }}
          >
            <div
              style={
                {
                  // marginBottom: "50px",
                  // border: "2px solid blue",
                  // borderColor: "blue",
                  // borderRadius: "25",
                  // padding: "50",
                  // backgroundColor: "lightsteelblue"
                }
              }
            >
              <Paper>
                <div
                  className={styles.container}
                  style={{ paddingTop: "50px" }}
                >
                  <div align="center">
                    {" "}
                    <img src={logo} alt={"logo"} />
                  </div>
                  <p>&nbsp;</p>
                  <div align="center">
                    <h5>&nbsp;</h5>
                  </div>
                  <p>&nbsp;</p>
                  {this.state.isSignedIn !== undefined &&
                    !this.state.isSignedIn && (
                      <div>
                        <StyledFirebaseAuth
                          className={styles.firebaseUi}
                          uiConfig={this.uiConfig}
                          firebaseAuth={firebase.auth()}
                        />
                      </div>
                    )}
                  {/* {this.state.isSignedIn && (
                    <div className={styles.signedIn}>
                      Hello {firebase.auth().currentUser.displayName}. You are
                      now signed In!
                      <a
                        className={styles.button}
                        onClick={() => firebase.auth().signOut()}
                      >
                        Sign-out
                      </a>
                    </div>
                  )} */}
                </div>
                <div>
                  <h6 align="center" style={{ marginTop: "100px" }}>
                    &copy; Algemene Hulpdienst Heemskerk: Opgericht in 1978
                    {/* {" "}
                    {new Date().getFullYear()} */}
                  </h6>
                </div>
              </Paper>
            </div>
          </div>
        );
      }
    }
  }
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js